import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DURATION, EASE } from "./animation-config.js";

gsap.registerPlugin(ScrollTrigger);

const HEADLINE_X = "-100vw";
const CONTENT_Y = "100%";

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

function initGoogleRatingSection(section) {
  const headline = section.querySelector(".google-rating__headline");
  const content = section.querySelector(".google-rating__content");

  if (!headline && !content) {
    return;
  }

  if (reducedMotion) {
    if (headline) {
      gsap.set(headline, { x: 0, opacity: 1 });
    }

    if (content) {
      gsap.set(content, { y: 0 });
    }

    section.classList.add("is-in-view");
    return;
  }

  if (headline) {
    gsap.set(headline, { x: HEADLINE_X, opacity: 0 });
  }

  if (content) {
    gsap.set(content, { y: CONTENT_Y });
  }

  ScrollTrigger.create({
    trigger: section,
    start: "top 70%",
    once: true,
    onEnter: () => {
      section.classList.add("is-in-view");

      const timeline = gsap.timeline({
        defaults: { duration: DURATION, ease: EASE },
      });

      if (headline) {
        timeline.to(headline, { x: 0, opacity: 1 }, 0);
      }

      if (content) {
        timeline.to(content, { y: 0 }, 0);
      }
    },
  });
}

document.querySelectorAll(".google-rating").forEach(initGoogleRatingSection);

window.addEventListener(
  "load",
  () => {
    ScrollTrigger.refresh();
  },
  { once: true },
);
